import React, { FC } from 'react'

import { PharmacyListResponse } from '@/features/auth/types/pharmacy'
import {
  NotionSelect,
  type NotionSelectOption,
} from '@/apps/latest/components/portal/notion'

interface PharmacySelectorProps {
  value: string
  onChange: (value: string) => void
  pharmacyData: PharmacyListResponse | null
  disabled?: boolean
  fullWidth?: boolean
  /** caller compat. NotionSelect 内部で size="small" 固定. */
  size?: 'small' | 'medium'
  label?: string
  showAllOption?: boolean
}

export const PharmacySelector: FC<PharmacySelectorProps> = ({
  value,
  onChange,
  pharmacyData,
  disabled = false,
  fullWidth = true,
  label = '表示薬局',
  showAllOption = false,
}) => {
  const hasHq = pharmacyData?.has_headquarters_permission ?? false
  const options: NotionSelectOption<string>[] = [
    ...(showAllOption && hasHq ? [{ value: '', label: '全社' }] : []),
    ...(pharmacyData?.pharmacies ?? []).map((p) => ({
      value: p.id,
      label: p.name,
    })),
  ]

  return (
    <NotionSelect<string>
      label={label}
      value={value}
      onChange={onChange}
      options={options}
      disabled={disabled || !hasHq}
      fullWidth={fullWidth}
    />
  )
}
